// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__FgOd_","header":"MessagesList_header__2k-gc","chat":"MessagesList_chat__bx6Wa"};